export const loadAppleLoginScript = () => {
  const appleSDK = document.getElementById('appleSDKScript');
  if (!appleSDK) {
    // apple onload
    window.appleScriptCall = function () {
      window.AppleID.auth.init({
        clientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID,
        scope: 'name email',
        redirectURI: process.env.NEXT_PUBLIC_APPLE_REDIRECT_URI,
        state: 'origin:web',
        usePopup: true, //or false defaults to false
        responseMode: 'form_post'
      });
    };
    const appleSDKScript = document.createElement('script');
    appleSDKScript.setAttribute('onload', 'window.appleScriptCall();');
    appleSDKScript.setAttribute(
      'src',
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
    );
    appleSDKScript.setAttribute('defer', 'defer');
    appleSDKScript.setAttribute('id', 'appleSDKScript');
    document.head.appendChild(appleSDKScript);
  }
};

export const loadFbLoginScript = () => {
  const fbSDK = document.getElementById('facebookSDKScript');
  if (!fbSDK) {
    // fb onload
    window.fbLoad = function () {
      window.FB.init({
        appId: process.env.NEXT_PUBLIC_FB_ID,
        cookie: false, // enable cookies to allow the server to access // the session
        xfbml: true, // parse social plugins on this page
        version: 'v2.10' // use graph api version 2.5
      });
    };
    const facebookSDKScript = document.createElement('script');
    facebookSDKScript.setAttribute('onload', 'window.fbLoad();');
    facebookSDKScript.setAttribute(
      'src',
      'https://connect.facebook.net/en_US/sdk.js'
    );
    facebookSDKScript.setAttribute('defer', 'defer');
    facebookSDKScript.setAttribute('id', 'facebookSDKScript');
    document.head.appendChild(facebookSDKScript);
  }
};

export const loadGoogleLoginScript = () => {
  const googleSDK = document.getElementById('googleSDKScript');
  if (!googleSDK) {
    // google onload
    window.scriptCall = function () {
      window.gapi.load('auth2', () => {
        window.auth2 = window.gapi.auth2.init({
          client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
          cookiepolicy: 'single_host_origin',
          scope: 'profile'
        });
      });
    };
    const googleSDKScript = document.createElement('script');
    googleSDKScript.setAttribute('onload', 'window.scriptCall();');
    googleSDKScript.setAttribute(
      'src',
      'https://apis.google.com/js/platform.js'
    );
    googleSDKScript.setAttribute('defer', 'defer');
    googleSDKScript.setAttribute('id', 'googleSDKScript');
    document.head.appendChild(googleSDKScript);
  }
};
